var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canvasDetail
    ? _c(
        "b-row",
        _vm._l(_vm.canvasDetail.widgets, function(widget) {
          return _c(
            "b-col",
            {
              key: widget.form_data_id,
              attrs: { md: _vm.checkGrid(widget.grid) }
            },
            [
              _c(
                "div",
                { staticClass: "canvas-widget" },
                [
                  _c("p", { staticClass: "canvas-title" }, [
                    _vm._v(_vm._s(widget.name) + " | "),
                    _c("span", [_vm._v(_vm._s(widget.timeframe))])
                  ]),
                  _vm._v(" "),
                  widget.type === "text" &&
                  (widget.format_type === "text" ||
                    widget.format_type === "number")
                    ? _c("p", { staticClass: "canvas-text" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              widget.format_type === "text"
                                ? "Dummy Text"
                                : "12345"
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  widget.type === "text" && widget.format_type === "currency"
                    ? _c("p", { staticClass: "canvas-currency" }, [
                        _vm._v("\n        Rp 999.999.999\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  widget.type === "map"
                    ? _c("img", {
                        staticClass: "canvas-map",
                        attrs: {
                          src: require("@/assets/new-form-ui/map-dummy.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  widget.type === "bar_chart" ||
                  widget.type === "line_chart" ||
                  widget.type === "pie_chart"
                    ? _c("dummy-canvas-chart", {
                        attrs: { "data-component": widget }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  widget.type === "table"
                    ? _c("dummy-table-view", {
                        attrs: { "data-component": widget, "for-canvas": true }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a8fbe8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a8fbe8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyCanvas.vue
// module id = null
// module chunks = 